import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Sirve para primaria y secundaria?',
  a: 'Sí. Está diseñado para adaptarse por nivel con variantes.'
}, {
  q: '¿Necesito laboratorio?',
  a: 'No. Incluye prácticas simples con materiales comunes y alternativas cuando no hay recursos.'
}, {
  q: '¿Es imprimible?',
  a: 'Sí. Todo el material está preparado para impresión A4.'
}, {
  q: '¿Incluye planificación anual?',
  a: 'Sí. Incluye planificación anual, unidades y plantillas semanales.'
}, {
  q: '¿Cómo lo descargo?',
  a: 'Acceso inmediato al finalizar la compra. Recibirás un correo con el enlace de descarga.'
}, {
  q: '¿Es editable?',
  a: 'Incluye plantillas editables cuando corresponde para que puedas adaptar el contenido.'
}, {
  q: '¿Trae contenido útil o relleno?',
  a: 'Trae material aplicable real: guías, prácticas, actividades, evaluaciones, pautas y rúbricas.'
}, {
  q: '¿Y si no me sirve?',
  a: 'Tenés garantía de 7 días para comprar con tranquilidad. Si no es lo que esperabas, te devolvemos el dinero.'
}];
export const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 bg-stone-50" data-id="element-43">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-44">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-45">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-46">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg border border-stone-200 overflow-hidden" data-id="element-47">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none hover:bg-stone-50 transition-colors" data-id="element-48">
                <span className="font-bold text-gray-800" data-id="element-49">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-green-600" data-id="element-50" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-51" />}
              </button>
              <AnimatePresence data-id="element-52">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-53">
                    <div className="p-5 pt-0 text-gray-600 border-t border-stone-100" data-id="element-54">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};